import { createLanguageEngine } from './createLanguageEngine';

export const SUPPORTED_LOCALES = ['it-IT', 'en-GB', 'en-US'];

// Ogni file JSON in ./locales/<lingua>/ è una sezione di traduzioni del modulo
// (chiavi di primo livello distinte): basta aggiungere il file, senza elenchi
// di import da mantenere. Le chiavi comuni a tutti i moduli sono in ./kernel/.
const loadAll = (context) => context.keys().reduce((acc, key) => Object.assign(acc, context(key)), {});

const LOCALES = {
  'it-IT': loadAll(require.context('./locales/it-IT', false, /\.json$/)),
  'en-GB': loadAll(require.context('./locales/en-GB', false, /\.json$/)),
};

export const { isValidLocale, getLang, resolve, translate, LanguageProvider, useLanguage } =
  createLanguageEngine(LOCALES, SUPPORTED_LOCALES);
